
import React from 'react';
import { useState } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import ModeEditIcon from '@material-ui/icons/Edit';

const EditApplication = (props) => {
    const { apps } = props
    const [show, setShow] = useState(false);
    const [validated, setValidated] = useState(false);
    // const [apps, setApps] = useState(null)
    const [appValue, setAppValue] = useState(apps.route.id)
    // const [appList, setAppList] = useState([])
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);
    const [permission, setPermissionValue] = useState([
        {
            value: false,
            name: "All",
        },
        {
            value: false,
            name: "Create Notification Drawer",
        },
        {
            value: false,
            name: "Notification Drawer",
        }, {
            value: false,
            name: "Manage White List",
        }, {
            value: false,
            name: "Report Logs",
        }
    ]);
    const handleMarkComplete = (index, value) => {
        // 2. Mark the todo as complete
        const updatedPer = { ...permission[index], value: !value.value }
        // 3. Update the todo list with the updated todo
        const newPermission = [...permission];
        newPermission[index] = updatedPer;
        setPermissionValue(newPermission);
    };

    function selectApp(value) {
        // console.log(value)
        setAppValue(value.target.value)
        // setAppValue(value.target)
        // setAppValue(appList.find(apps => apps.id === id))
    }

    // const handleDone = () => {
    //     console.log('xxxx')
    //     console.log(appValue)
    //     if (appValue === null || appValue === "") {
    //         setValidated(true);
    //         return false
    //     } else {
    //         props.setApps(appValue, permission)
    //         handleClose()
    //     }
    // }
    // useEffect(() => {
    //     let pIndex = permission.findIndex((r) => r.name.toLowerCase() === apps.permission.name)
    //     let newPermission = permission.splice(pIndex, 0, "March");
    //     setPermissionValue(newPermission)
    // }, [])
    return (
        <>
            {/* <Button className="px-1" variant="link" onClick={handleShow} >
                <ModeEditIcon color="disabled" style={{ width: "18px", height: "18px" }} />
            </Button> */}
            {/* <Button variant="primary" onClick={handleShow} className="text-dark border">Add Application</Button> */}
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    {/* <Modal.Title>Modal heading</Modal.Title> */}
                    <h5>Service Permission</h5>
                </Modal.Header>
                <Modal.Body>
                    <Form noValidate validated={validated}>
                        <div className="d-flex justify-content-start">
                            <div className="col-md-12">
                                <div className="form-group w-75">
                                    <label htmlFor="InputApp">Application Access</label>
                                    <Form.Control as="select"
                                        defaultValue={appValue}
                                        onChange={selectApp}
                                        required
                                    >
                                        <option value={""}>เลือกแอพ</option>
                                        {
                                            props.appList.map(app => {
                                                return <option value={app.id} key={app.id}>{app.name}</option>
                                            })
                                        }
                                    </Form.Control>
                                </div>
                               <div className="form-group hide-feature">
                                    <label htmlFor="InputApp" className='mb-0'>Permission Access</label>
                                    {/* <ul className="list-group list-group-flush"> */}
                                    <ul className="list-group list-group-flush">
                                        {permission.map((p, i) =>
                                        (
                                            <li className="list-group-item pl-4 py-2" key={i}>
                                                <label htmlFor={`custom-checkbox-${i}`} className="mb-0 d-flex justify-content-between align-items-center mr-3">
                                                    <label htmlFor={`custom-checkbox-${i}`} className='mb-0'>{p.name}</label>
                                                    <div className="chiller_cb">
                                                        <input
                                                            id={`custom-checkbox-${i}`}
                                                            type="checkbox"
                                                            checked={p.value}
                                                            onChange={() => handleMarkComplete(i, p)}
                                                        // onChange={() => setPermissionValue([...permission, { ...permission[i], value: true }])}    
                                                        />
                                                        {/* <label for="myCheckbox">Checkbox checked</label> */}
                                                        <span></span>
                                                    </div>
                                                </label>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                {/* </form> */}
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-light" className="text-dark border px-4" onClick={handleClose}>
                        Cancel
                    </Button>
                    {/* <Button variant="primary" className="px-4" onClick={handleDone}>
                        Done
                    </Button> */}
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default EditApplication